import { TableFooter as MuiTableFooter, TableRow } from "@mui/material";
import { useBatchContractSweepPreviewContext } from "src/views/AssetManagement/BatchContractSweep/contexts";
import { TABLE_COLUMNS } from "./constants/tableColumns";
import StyledTableCell from "./components/StyledTableCell";
import OverflowTooltipText from "src/components/OverflowTooltipText";

function TableFooter() {
  const {
    toDisplayAmountWithCurrency,
    summaryDetails: { addressesSummary },
    translate: t,
  } = useBatchContractSweepPreviewContext();

  return (
    <MuiTableFooter>
      <TableRow>
        {TABLE_COLUMNS.map((column) => {
          let cellContent: string | undefined;
          let cellColor: string = "#4a90f7";

          switch (column.id) {
            case "select_all":
              cellContent = t("total");
              cellColor = "#000";
              break;
            // case "sweepable_amount":
            //   cellContent = toDisplayAmountWithCurrency(
            //     addressesSummary.totalSweepableAmount,
            //   );
            //   break;
            case "sweep_amount":
              cellContent = toDisplayAmountWithCurrency(
                addressesSummary.totalSweepAmount,
              );
              break;
            default:
              break;
          }

          return (
            <StyledTableCell
              key={column.id}
              sx={{
                color: cellColor,
                background: "#fff !important",
                borderBottom: "0px",
                fontSize: "0.6875rem",
              }}
              align={"center"}
            >
              {cellContent && <OverflowTooltipText text={cellContent} />}
            </StyledTableCell>
          );
        })}
      </TableRow>
    </MuiTableFooter>
  );
}

export default TableFooter;
